import styled, { css } from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Body, Small } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';
import DefaultActionButton from 'components/Buttons/ActionButton';

export const Content = styled.div`
  padding: 1rem 0 1rem 0.5rem;
  border-radius: 1rem;
`;

export const Dot = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.75rem;
  margin-left: 0.5rem;
  margin-right: 0.75rem;
  background-color: transparent;
`;

export const Container = styled.div<{ $unseen: boolean }>`
  height: 5.5rem;
  padding: 0.25rem 1rem 0.25rem 0.5rem;

  ${Content} {
    display: grid;
    grid-template-columns: 2rem 1.5fr 1.5fr 1fr 1fr 5.625rem 1fr 6.5rem;
    align-items: center;

    > *:nth-child(7) {
      justify-self: flex-end;
    }
  }

  :hover {
    cursor: pointer;

    ${Content} {
      background-color: ${({ theme }) => theme.colors.gray1};
    }
  }

  ${({ theme, $unseen }) =>
    $unseen &&
    css`
      ${Content} {
        background-color: ${theme.colors.gray1};
      }

      :hover {
        ${Content} {
          background-color: ${theme.colors.gray2};
        }
      }

      ${Dot} {
        background-color: ${theme.colors.blueMedium};
      }
    `}
`;

export const MainText = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
  font-weight: 600;
`;

export const Text = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

export const Date = styled(Text)`
  font-variant-numeric: tabular-nums;
`;

export const SecondaryText = styled(Small)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

export const Avatar = styled(DefaultAvatar)`
  margin-right: 1rem;
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.div`
  background-color: ${({ theme }) => theme.colors.yellowLight};
  color: ${({ theme }) => theme.colors.yellowDark};
  width: 7.5rem;
  height: 3rem;
  right: 11rem;
  border-radius: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled(DefaultActionButton)`
  margin-left: 2rem;
`;
